/**
 * /public/css/form.css
 */

import React from "react";

export default function InputAutoresize(props) {
    const refTextarea = React.useRef(null);

    React.useEffect(() => {
        resize();
    }, [props.value]);

    function resize() {
        const domTextarea = refTextarea.current;

        if (!domTextarea) {
            return;
        }

        const prevHeight = parseFloat(domTextarea.style.getPropertyValue("height"));

        domTextarea.style.setProperty("height", `auto`);
        domTextarea.style.setProperty("height", `${domTextarea.scrollHeight}px`);

        const newHeight = parseFloat(domTextarea.style.getPropertyValue("height"));

        prevHeight !== newHeight && setTimeout(() => resize, 100);
    }

    // Combine component className
    const className = ["input-autoresize"];
    Array.isArray(props.className) && className.push.call(className, props.className);
    typeof props.className === "string" && className.push(props.className);
    props.small && className.push("small");
    props.fullWidth && className.push("full-width");

    // Clean props
    const cleanProps = { ...props };
    delete cleanProps.trimOnBlur;
    delete cleanProps.multirow;
    delete cleanProps.style;
    delete cleanProps.small;
    delete cleanProps.fullWidth;

    //
    function onChange(event) {
        if (!props.multirow) {
            event.target.value = event.target.value.replace(/[\r\n]+/g, "");
        }

        props.onChange.apply(this, arguments);
    }

    // Trim
    let onBlur = props.onBlur;

    if (props.trimOnBlur) {
        if (onBlur) {
            throw new Error(`props.onBlur conflicts with props.trimOnBlur`);
        }

        onBlur = function (event) {
            if (!props.multirow) {
                event.target.value = event.target.value.replace(/[\r\n]+/g, "");
            }

            event.target.value = event.target.value.trim();
            (props.onBlur || props.onChange).apply(this, arguments);
        };
    }

    const rows = props.multirow || props.rows > 1 ? props.rows ?? 2 : 1;

    return (
        <>
            <label
                className={className.join(" ")}
                onClick={() => refTextarea?.current?.focus()}
                style={{ ...props.style }}
            >
                <textarea ref={refTextarea} {...cleanProps} onBlur={onBlur} onChange={onChange} rows={rows} />
            </label>

            {props.error !== undefined && <div className="input-base-error">{props.error || <>&nbsp;</>}</div>}
        </>
    );
}
